import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: #2c2f42;
}

input {
  outline: none !important;
}

*, :after, :before {
  box-sizing: border-box;
}
@font-face {
  font-family: Source Sans Pro;
  font-weight: 400;
  font-display: fallback;
  font-style: normal;
  src: url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/400.ttf)
      format('truetype'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/400.woff)
      format('woff'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/400.woff2)
      format('woff2');
}
@font-face {
  font-family: Source Sans Pro;
  font-weight: 600;
  font-display: fallback;
  font-style: normal;
  src: url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/600.ttf)
      format('truetype'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/600.woff)
      format('woff'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/600.woff2)
      format('woff2');
}
@font-face {
  font-family: Source Sans Pro;
  font-weight: 700;
  font-display: fallback;
  font-style: normal;
  src: url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/700.ttf)
      format('truetype'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/700.woff)
      format('woff'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/source-sans/700.woff2)
      format('woff2');
}
*,
:after,
:before {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  font-family: Source Sans Pro, sans-serif;
}
a {
  text-decoration: none;
  outline: 0 none;
  color: #1895b3;
}
a:focus, a:hover {
  color: #148099;
}
ol, ul {
  margin-top: 0;
  margin-bottom: 11.5px;
}
.h1, .h2, .h3, h1, h2, h3 {
  margin-top: 23px;
  margin-bottom: 11.5px;
}
.h4, .h5, .h6, h4, h5, h6 {
  margin-top: 11.5px;
  margin-bottom: 11.5px
}
p {
  margin: 0 0 11.5px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}
.pos-r {
  position: relative;
}

@font-face {
  font-family: pyticon;
  src: url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/pyt/20201111/pyticons.eot);
  src: url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/pyt/20201111/pyticons.eot?#iefix)
      format('embedded-opentype'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/pyt/20201111/pyticons.ttf)
      format('truetype'),
    url(https://d3lf10b5gahyby.cloudfront.net/web_app/fonts/pyt/20201111/pyticons.woff)
      format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}

[class*=" pyt-"], [class^=pyt-] {
  font-family: pyticon;
  speak: never;
  font-style: normal;
  font-weight: 400;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent
}

.dropdown,.dropup {
  position: relative
}

.dropdown-toggle:focus {
  outline: 0
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 17px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
    background-clip: padding-box
}

.dropdown-menu.pull-right {
    right: 0;
    left: auto
}

.dropdown-menu .divider {
    height: 1px;
    margin: 10.5px 0;
    overflow: hidden;
    background-color: #e5e5e5
}

.dropdown-menu>li>a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.41;
    color: #555b7f;
    white-space: nowrap
}

.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover {
    text-decoration: none;
    color: #4b5070;
    background-color: #f5f5f5
}

.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover {
    color: #fff;
    text-decoration: none;
    outline: 0;
    background-color: #26cf96
}

.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover {
    color: #9ea2be
}

.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover {
    text-decoration: none;
    background-color: initial;
    background-image: none;
    filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
    cursor: not-allowed
}

.open>.dropdown-menu {
    display: block
}

.open>a {
    outline: 0
}

.dropdown-menu-right {
    left: auto;
    right: 0
}

.dropdown-menu-left {
    left: 0;
    right: auto
}

.dropdown-header {
    display: block;
    padding: 3px 20px;
    font-size: 15px;
    line-height: 1.41;
    color: #9ea2be;
    white-space: nowrap
}

.dropdown-backdrop {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 990
}

.rating-yellow {
  .rating {
    display: flex;
  }
  i {
    font-size: 24px;

    color: #E5B52E;
    padding-right: 4px;
  
    :not(:last-child) {
      padding-right: 0px;
    }
  }
}

.rating-yellow.size-16 {
  i {
    font-size: 16px;
  }
}

.pull-right>.dropdown-menu {
    right: 0;
    left: auto
}

.dropup .caret,.navbar-fixed-bottom .dropdown .caret {
    border-top: 0;
    border-bottom: 4px dashed;
    border-bottom: 4px solid;
    content: ""
}

.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu {
    top: auto;
    bottom: 100%;
    margin-bottom: 2px
}

@media (min-width: 768px) {
    .navbar-right .dropdown-menu {
        left:auto;
        right: 0
    }

    .navbar-right .dropdown-menu-left {
        left: 0;
        right: auto
    }
}

.dropdown-menu li,
.dropdown-menu li a {
  color: rgba(44,47,66,.6)
}

.dropdown-menu li a:hover {
  transition: all .4s ease;
  padding-left: 24px;
  background-color: rgba(24,149,179,.04);
  color: #1895b3
}

.sticky-outer-wrapper {
  width: 100%;
}

.spl-tag.promote-tag {
  padding: 8px 24px;
  font-weight: 700;
  margin-top: 22px;

  &.discover {
    &:after {
      background: #3072d4;
    }
  }
  &.experience {
    &:after {
      background: #00c67f;
    }
  }
  &.indulge {
    &:after {
      background: #603ab1;
    }
  }
}

.pyt-arrow-down-circle-24:before {
  content: '\\e9d2';
}
.pyt-phone-24:before {
  content: '\\e952';
}
.pyt-star-16:before {
  content: '\\e9ae';
}
.pyt-star-24:before {
  content: '\\e9f5';
}
.pyt-star-outline-16:before {
  content: '\\e9af';
}
.pyt-half-star-16:before {
  content: '\\e996';
}
.pyt-tickmark-16:before {
  content: '\\e910';
}
.pyt-tickmark-24:before {
  content: '\\e911';
}
.pyt-excluded-16:before {
  content: '\\ea08';
}
.pyt-excluded-24:before {
  content: '\\ea0c';
}
.pyt-baggage-24:before {
  content: '\\ea56';
}
.pyt-calendar-24:before {
  content: '\\e94b';
}
.pyt-flight-departure-24:before {
  content: '\\e960';
}
.pyt-visa-24:before {
  content: '\\e974';
}
.pyt-home-16:before {
  content: '\\ea31';
}
.pyt-more-horizontal-16:before {
  content: '\\e935';
}
.pyt-facebook-16:before {
  content: '\\e924';
}
.pyt-twitter-16:before {
  content: '\\e943';
}
.pyt-instagram-16:before {
  content: '\\eae0';
}
.pyt-global-24:before {
  content: '\\ead2';
}
.pyt-close-16:before {
  content: '\\e91f';
}
.pyt-close-circle-16:before {
  content: '\\e989';
}
.pyt-minus-16:before {
  content: '\\e900';
}
.pyt-plus-16:before {
  content: '\\e901';
}
.pyt-email-16:before {
  content: '\\e98f';
}
.pyt-phone-16:before {
  content: '\\e922';
}
.pyt-whatsapp-16:before {
  content: '\\e946';
}

* {
    font-family: Source Sans Pro;
  }
`

export default GlobalStyle
